import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/layout'
import Header from '../components/header'
import Career from '../components/career'
import Subscribe from '../components/subscribe'

const Results = ({ data }) => {
	return (
  <Layout siteTitle={data.primary.edges[0].node.name} secondary={data.secondary.edges[0].node} tertiary={data.tertiary.edges[0].node} >
    <Header />
    <Career
      primary={data.primary.edges[0].node}
      image={data.image}
      imageMobile={data.imageMobile}
      imageAbout={data.imageAbout}
      imageAboutMobile={data.imageAboutMobile}
      imageAreaOne={data.imageAreaOne}
      imageProfile={data.imageProfile}
      imageProfileMobile={data.imageProfileMobile}
      imageRoleOne={data.imageRoleOne}
      imageRoleTwo={data.imageRoleTwo}
      imageRoleThree={data.imageRoleThree}
      imageAreaTwo={data.imageAreaTwo}
      imageProfileAlternate={data.imageProfileAlternate}
      imageProfileAlternateMobile={data.imageProfileAlternateMobile}
      imageRoleAlternateOne={data.imageRoleAlternateOne}
      imageRoleAlternateTwo={data.imageRoleAlternateTwo}
      imageRoleAlternateThree={data.imageRoleAlternateThree}
      secondary={data.secondary.edges[0].node}
      secondaryImageMobile={data.secondaryImageMobile}
      tertiary={data.tertiary.edges[0].node}
      tertiaryImageMobile={data.tertiaryImageMobile}
    />
		<Subscribe />
  </Layout>
)
	}

export const query = graphql`
  query GetResultDetails(
    $name: String
    $image: String
    $imageMobile: String
    $imageAbout: String
    $imageAboutMobile: String
    $imageAreaOne: String
    $imageProfile: String
    $imageProfileMobile: String
    $imageRoleOne: String
    $imageRoleTwo: String
    $imageRoleThree: String
    $imageAreaTwo: String
    $imageProfileAlternate: String
    $imageProfileAlternateMobile: String
    $imageRoleAlternateOne: String
    $imageRoleAlternateTwo: String
    $imageRoleAlternateThree: String
    $secondaryName: String
    $secondaryImageMobile: String
    $tertiaryName: String
    $tertiaryImageMobile: String
  ) {
    primary: allCareersJson(filter: { name: { eq: $name } }) {
      edges {
        node {
          ...careerDetails
        }
      }
    }
    image: file(relativePath: { eq: $image }) {
      ...image
    }
    imageMobile: file(
      relativePath: { eq: $imageMobile }
    ) {
      ...imageMobile
    }
    imageAbout: file(relativePath: { eq: $imageAbout }) {
      ...image
    }
    imageAboutMobile: file(
      relativePath: { eq: $imageAboutMobile }
    ) {
      ...imageMobile
    }
    imageAreaOne: file(relativePath: { eq: $imageAreaOne }) {
      ...image
    }
    imageProfile: file(relativePath: { eq: $imageProfile }) {
      ...image
    }
    imageProfileMobile: file(relativePath: { eq: $imageProfileMobile }) {
      ...imageMobile
    }
    imageRoleOne: file(relativePath: { eq: $imageRoleOne }) {
      ...image
    }
    imageRoleTwo: file(relativePath: { eq: $imageRoleTwo }) {
      ...image
    }
    imageRoleThree: file(relativePath: { eq: $imageRoleThree }) {
      ...image
    }
    imageAreaTwo: file(relativePath: { eq: $imageAreaTwo }) {
      ...image
    }
    imageProfileAlternate: file(relativePath: { eq: $imageProfileAlternate }) {
      ...image
    }
    imageProfileAlternateMobile: file(relativePath: { eq: $imageProfileAlternateMobile }) {
      ...imageMobile
    }
    imageRoleAlternateOne: file(relativePath: { eq: $imageRoleAlternateOne }) {
      ...image
    }
    imageRoleAlternateTwo: file(relativePath: { eq: $imageRoleAlternateTwo }) {
      ...image
    }
    imageRoleAlternateThree: file(relativePath: { eq: $imageRoleAlternateThree }) {
      ...image
    }
    secondary: allCareersJson(filter: { name: { eq: $secondaryName } }) {
      edges {
        node {
          ...careerSummary
        }
      }
    }
    secondaryImageMobile: file(
      relativePath: { eq: $secondaryImageMobile }
    ) {
      ...imageMobile
    }
    tertiary: allCareersJson(filter: { name: { eq: $tertiaryName } }) {
      edges {
        node {
          ...careerSummary
        }
      }
    }
    tertiaryImageMobile: file(
      relativePath: { eq: $tertiaryImageMobile }
    ) {
      ...imageMobile
    }
  }
`

export default Results
